import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const IssueRefundConfirmationModal = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('Emitir reembolso')} size="l" onClose={onClose} show={show}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Al cambiar esta transacción al estado “Recibido” se emitirá el reembolso automáticamente, siguiendo configuración establecida para tu tienda. ¿Quieres confirmar la operación?'
          )}
        </Text>
        <Alert type="info">
          {t('Si quieres cambiar esta configuración, puedes hacerlo en la página Configuración > Reembolsos.')}
        </Alert>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined" fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={onConfirm}
            defaultLabel={t('Confirmar')}
            loadingLabel={t('Confirmando')}
            fullWidth
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default IssueRefundConfirmationModal
